import React from 'react';
import { Eye, Heart, MapPin, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import DashboardCard from './DashboardCard';
import { Button } from '@/components/ui/button';

const ActivityFeed = () => {
  // Mock activity data - in real app this would come from database
  const activities = [
    {
      id: 1,
      type: 'viewed',
      terrace: 'Café Nizza',
      time: new Date(Date.now() - 1000 * 60 * 30), // 30 minutes ago
      icon: <Eye className="h-4 w-4" />
    },
    {
      id: 2,
      type: 'favorited',
      terrace: 'Rooftop Bar Central',
      time: new Date(Date.now() - 1000 * 60 * 60 * 2), // 2 hours ago
      icon: <Heart className="h-4 w-4 text-coral-pink" />
    },
    {
      id: 3,
      type: 'visited',
      terrace: 'Gamla Stan Terrace',
      time: new Date(Date.now() - 1000 * 60 * 60 * 6), // 6 hours ago
      icon: <MapPin className="h-4 w-4 text-peach-orange" />
    }
  ];

  const getActivityText = (activity: typeof activities[0]) => {
    switch (activity.type) {
      case 'viewed': return `Viewed ${activity.terrace}`;
      case 'favorited': return `Added ${activity.terrace} to favorites`;
      case 'visited': return `Visited ${activity.terrace}`;
      default: return '';
    }
  };

  return (
    <DashboardCard
      title="Recent Activity"
      description="Your latest terrace interactions"
      icon={<Clock className="h-5 w-5" />}
      isPlaceholder
      placeholderText="Enhanced Tracking Coming"
      action={
        <Button variant="ghost" size="sm" className="text-xs">
          View All
        </Button>
      }
    >
      <div className="space-y-3">
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-center space-x-3 p-2 rounded-lg hover:bg-warm-cream/30 transition-colors">
            <div className="flex-shrink-0">
              {activity.icon}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">
                {getActivityText(activity)}
              </div>
              <div className="text-xs text-muted-foreground">
                {formatDistanceToNow(activity.time, { addSuffix: true })}
              </div>
            </div>
          </div>
        ))}
        
        {activities.length === 0 && (
          <div className="text-center py-4 text-sm text-muted-foreground">
            Start exploring to see your activity here
          </div>
        )}
      </div>
    </DashboardCard>
  );
};

export default ActivityFeed;